import { useQuery } from '@tanstack/react-query';
import { api } from '@/shared/api/axios';
import { useAuth } from '@/context/AuthContext';

export interface UserOption {
  id: string;
  name: string;
  department: string;
}

/**
 * The people a chat can be started with. This is the chat directory (the
 * requester's own organization, active people only) rather than
 * GET /users/assignable, which is the whole platform roster and so lists
 * people the chat would refuse to add.
 */
export function useAllUsers() {
  const { user } = useAuth();
  return useQuery({
    queryKey: ['chat', 'people', user?.id],
    queryFn: async () => {
      const res = await api.get<{ people: UserOption[] }>('/chat/people');
      return (res.data?.people ?? []).filter((p) => p.id !== user?.id);
    },
    enabled: !!user?.id,
  });
}
